import { AbstractGridStrategy, type IGridStrategy } from './abstract.strategy';

export class GroupHeightGridStrategy extends AbstractGridStrategy {
    constructor(
        protected groupCount: number,
        height: number,
        protected draggableGrid: boolean = false
    ) {
        super();
        this.gridHeight = height;
    }

    public getGridHeight(): number {
        return this.gridHeight;
    }

    public getGridPageAmount(): number {
        let freeSpace = this.getGridHeight();
        if (this.headerHeight) {
            freeSpace -= this.headerHeight;
        }
        let items = Math.floor(freeSpace / this.a9GridConstants.dataRowHeight);
        const rest = items % this.groupCount;
        items = rest > 0 ? items - rest : items;
        items = items < this.groupCount ? this.groupCount : items;
        if (this.draggableGrid) {
            items += 1;
        }
        return items;
    }

    public showPagination() {
        return true;
    }
    public detach() {}
    public setGridElement(gridElement: HTMLElement): void {}
}
